import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";
import dfSubDays from "date-fns/subDays";
import { formatDate, getDateByTimeZone } from "@/lib/date";
import { Delivery } from "@/Models";
import { useApiStore } from "@/store/hooks";

export const ALLOCATE_TYPES = {
  DELIVERY: "DELIVERY",
  PICKUP: "PICKUP",
};

export const CONSTANTS = {
  SET_COUNT: "SET_COUNT",
  SET_COUNT_PARTIAL: "SET_COUNT_PARTIAL",
  SET_COUNT_DELAYED: "SET_COUNT_DELAYED",
  SET_QUERY: "SET_QUERY",
  FETCH_ALL: "FETCH_ALL",
  FETCH_ALL_DELAYED: "FETCH_ALL_DELAYED",
  RESET: "RESET",
  RESET_QUERY: "RESET_QUERY",
};

export const QUERY_DATE_TYPE_RECEIPT_DATE = "RECEIPT_DATE";
export const QUERY_DATE_TYPE_DELIVERY_ALLOCATION_DATE =
  "DELIVERY_ALLOCATION_DATE";
export const QUERY_DATE_TYPE_PICKUP_COMPLETED_DATE = "PICKUP_COMPLETED_DATE";
export const QUERY_DATE_TYPE_DELIVERY_COMPLETED_DATE =
  "DELIVERY_COMPLETED_DATE";

export const QUERY_DELIVERY_TYPE_ALL = "ALL";
export const QUERY_DELIVERY_TYPE_RECEIPTED = "RECEIPTED";
export const QUERY_DELIVERY_TYPE_PICKUP_SCHEDULED = "PICKUP_SCHEDULED";
export const QUERY_DELIVERY_TYPE_PICKUP_COMPLETED = "PICKUP_COMPLETED";
export const QUERY_DELIVERY_TYPE_WAREHOUSED = "WAREHOUSED";
export const QUERY_DELIVERY_TYPE_DELIVERY_ALLOCATED = "DELIVERY_ALLOCATED";
export const QUERY_DELIVERY_TYPE_DELIVERY_POSTPONED = "DELIVERY_POSTPONED";
export const QUERY_DELIVERY_TYPE_DELIVERY_STARTED = "DELIVERY_STARTED";
export const QUERY_DELIVERY_TYPE_DELIVERY_COMPLETED = "DELIVERY_COMPLETED";
export const QUERY_DELIVERY_TYPE_ACCIDENT = "ACCIDENT";
export const QUERY_DELIVERY_TYPE_CANCELED = "CANCELED";
export const QUERY_DELIVERY_TYPE_TYPE_PICKUP = "TYPE_PICKUP";
export const QUERY_DELIVERY_TYPE_TYPE_RETURN = "TYPE_RETURN";
export const QUERY_DELIVERY_TYPE_SENDER_ADDRESS_ERROR = "SENDER_ADDRESS_ERROR";
export const QUERY_DELIVERY_TYPE_SENDER_ADDRESS_ERROR_CANCELED =
  "SENDER_ADDRESS_ERROR_CANCELED";
export const QUERY_DELIVERY_TYPE_RECEIVER_ADDRESS_ERROR =
  "RECEIVER_ADDRESS_ERROR";
export const QUERY_DELIVERY_TYPE_RECEIVER_ADDRESS_ERROR_CANCELED =
  "RECEIVER_ADDRESS_ERROR_CANCELED";
export const QUERY_DELIVERY_TYPE_DELIVERY_SENT_BACK = "DELIVERY_SENT_BACK";
export const QUERY_DELIVERY_TYPE_DELIVERY_LOST = "DELIVERY_LOST";
export const QUERY_DELIVERY_TYPE_MOBILE_ERROR = "MOBILE_ERROR";
export const QUERY_DELIVERY_TYPE_DELAYED = "DELAYED";
export const QUERY_DELIVERY_TYPE_ADDRESS_NOT_SUPPORTED =
  "ADDRESS_NOT_SUPPORTED";
export const QUERY_DELIVERY_TYPE_ADDRESS_NOT_SUPPORTED_CANCELED =
  "ADDRESS_NOT_SUPPORTED_CANCELED";
export const QUERY_DELIVERY_TYPE_AGENCY_ALLOCATION_KOOKMIN =
  "AGENCY_ALLOCATION_KOOKMIN"; // 배달 대행(국민배달)
export const QUERY_DELIVERY_TYPE_AGENCY_ALLOCATION_FAILED =
  "AGENCY_ALLOCATION_FAILED"; // 배달 대행 실패(국민배달)

export const AGENCY_KOOKMIN_USERNAME = "kookminfsd";
export const AGENCY_KOOKMIN_CORPTITLE = "국민fsd";

export const REGION_TYPE_SIGUNGU = "sigungu";
export const REGION_TYPE_SIDO = "sido";

export const REGIONS = [
  {
    id: "SEOUL",
    name: "서울",
    displayName: "서울",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "GOYANG",
    name: "고양",
    displayName: "고양",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "BUCHEON",
    name: "부천",
    displayName: "부천",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "SEONGNAM",
    name: "성남",
    displayName: "성남",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "HANAM",
    name: "하남",
    displayName: "하남",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GWANGMYEONG",
    name: "광명",
    displayName: "광명",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GWACHEON",
    name: "과천",
    displayName: "과천",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GUNPO",
    name: "군포",
    displayName: "군포",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "SUWON",
    name: "수원",
    displayName: "수원",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "ANSAN",
    name: "안산",
    displayName: "안산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "ANYANG",
    name: "안양",
    displayName: "안양",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "UIWANG",
    name: "의왕",
    displayName: "의왕",
    regionType: REGION_TYPE_SIGUNGU,
  },

  {
    id: "YONGIN",
    name: "용인",
    displayName: "용인",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "HWASEONG",
    name: "화성",
    displayName: "화성",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GIMPO",
    name: "김포",
    displayName: "김포",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GWANGJU",
    name: "광주",
    displayName: "광주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "OSAN",
    name: "오산",
    displayName: "오산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "UIJUNGBU",
    name: "의정부",
    displayName: "의정부",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "YANGJU",
    name: "양주",
    displayName: "양주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GURI",
    name: "구리",
    displayName: "구리",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "NAMYANGJU",
    name: "남양주",
    displayName: "남양주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "SIHEUNG",
    name: "시흥",
    displayName: "시흥",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "PAJU",
    name: "파주",
    displayName: "파주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "YEOJU",
    name: "여주",
    displayName: "여주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "ICHUN",
    name: "이천",
    displayName: "이천",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "PYEONGTAEK",
    name: "평택",
    displayName: "평택",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "ANSEONG",
    name: "안성",
    displayName: "안성",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "WONJU",
    name: "원주",
    displayName: "강원원주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "INCHEON",
    name: "인천",
    displayName: "인천광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "BUSAN",
    name: "부산",
    displayName: "부산광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "ULSAN",
    name: "울산",
    displayName: "울산광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "GWANGJU_GWANG",
    name: "광주",
    displayName: "광주광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "DAEJEON",
    name: "대전",
    displayName: "대전광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "DAEGU",
    name: "대구",
    displayName: "대구광역시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "SEJONG",
    name: "세종",
    displayName: "세종특별자치시",
    regionType: REGION_TYPE_SIDO,
  },
  {
    id: "GYUNGNAM_YANGSAN",
    name: "양산",
    displayName: "경남양산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GYUNGNAM_GIMHAE",
    name: "김해",
    displayName: "경남김해",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GYUNGNAM_CHANGWON",
    name: "창원",
    displayName: "경남창원",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GYEONGBUK_GYEONGSAN",
    name: "경산",
    displayName: "경북경산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GYEONGBUK_GYEONGJU",
    name: "경주",
    displayName: "경북경주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "GYEONGBUK_POHANG",
    name: "포항",
    displayName: "경북포항",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONBUK_JEONJU",
    name: "전주",
    displayName: "전북전주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONBUK_IKSAN",
    name: "익산",
    displayName: "전북익산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONBUK_WANJU",
    name: "완주",
    displayName: "전북완주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONBUK_GUNSAN",
    name: "군산",
    displayName: "전북군산",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONBUK_GIMJE",
    name: "김제",
    displayName: "전북김제",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONNAM_NAJU",
    name: "나주",
    displayName: "전남나주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONNAM_HWASUN",
    name: "화순",
    displayName: "전남화순",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONNAM_GANGYANG",
    name: "광양",
    displayName: "전남광양",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONNAM_SUNCHUN",
    name: "순천",
    displayName: "전남순천",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEONNAM_YEOSU",
    name: "여수",
    displayName: "전남여수",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "CHUNGBUK_CHUNGJU",
    name: "청주",
    displayName: "충북청주",
    regionType: REGION_TYPE_SIGUNGU,
  },
  {
    id: "JEJU",
    name: "제주",
    displayName: "제주",
    regionType: REGION_TYPE_SIDO,
  },
];

const zonedDateYesterday = dfSubDays(getDateByTimeZone(), 1);
const zonedDateToday = getDateByTimeZone();
const initDateFrom = formatDate(zonedDateYesterday);
const initDateTo = formatDate(zonedDateToday);

const INITIAL_QUERY = {
  allocationGroupName: "",
  bookId: "",
  corpUser: "",
  corpUserName: "",
  corpUserId: "",
  dateType: QUERY_DATE_TYPE_RECEIPT_DATE,
  dateFrom: initDateFrom,
  dateTo: initDateTo,
  orderBy: "",
  orderIdFromCorp: "",
  orderIdFromCorpSub: "",
  orderingNumberByDeliveryRiderId: "",
  page: 1,
  pageSize: 100,
  receiverAddressRoad: "",
  receiverDong: "",
  receiverMobile: "",
  receiverName: "",
  region: "",
  regionType: "",
  rider: "",
  pickupRiderName: "",
  productName: "",
  deliveryRiderName: "",
  senderDong: "",
  spotName: "",
  senderName: "",
  senderMobile: "",
  queryTypes: [QUERY_DELIVERY_TYPE_ALL],
  types: "1;2;3",
};

const INITIAL_STATE = {
  count: {
    all: "-",
    receipted: "-",
    pickupScheduled: "-",
    pickupCompleted: "-",
    warehoused: "-",
    deliveryAllocated: "-",
    postponed: "-",
    deliveryStarted: "-",
    deliveryCompleted: "-",
    accident: "-",
    canceled: "-",
    typePickup: "-",
    typeReturn: "-",
    senderAddressError: "-",
    senderAddressErrorCanceled: "-",
    receiverAddressError: "-",
    receiverAddressErrorCanceled: "-",
    deliverySentBack: "-",
    deliveryLost: "-",
    mobileError: "-",
    delayed: "-",
    addressNotSupported: "-",
    addressNotSupportedCanceled: "-",
  },
  deliveries: [],
  deliveriesWholeData: [],
  pageCount: 1,
  query: INITIAL_QUERY,
  reset: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.FETCH_ALL:
      return {
        ...state,
        deliveriesWholeData: action.deliveriesWholeData,
        deliveries: action.deliveries,
        pageCount: action.pageCount,
      };
    case CONSTANTS.FETCH_ALL_DELAYED:
      return {
        ...state,
        deliveries: action.deliveries,
      };
    case CONSTANTS.RESET:
      return {
        ...state,
        reset: action.reset,
      };
    case CONSTANTS.RESET_QUERY:
      return {
        ...state,
        query: INITIAL_QUERY,
        reset: true,
      };
    case CONSTANTS.SET_COUNT:
      return {
        ...state,
        count: {
          ...action.count,
          delayed: action.countDelayed,
          all:
            action.count.receipted +
            action.count.pickupScheduled +
            action.count.pickupCompleted +
            action.count.warehoused +
            action.count.deliveryAllocated +
            action.count.postponed +
            action.count.deliveryStarted +
            action.count.deliveryCompleted,
        },
      };
    case CONSTANTS.SET_COUNT_PARTIAL:
      const updatedCount = {
        ...state.count,
        [action.key]: action.value,
      };

      if (
        updatedCount.receipted === "-" ||
        updatedCount.pickupScheduled === "-" ||
        updatedCount.pickupCompleted === "-" ||
        updatedCount.warehoused === "-" ||
        updatedCount.deliveryAllocated === "-" ||
        updatedCount.postponed === "-" ||
        updatedCount.deliveryStarted === "-" ||
        updatedCount.deliveryCompleted === "-"
      ) {
        return {
          ...state,
          count: {
            ...updatedCount,
          },
        };
      }

      return {
        ...state,
        count: {
          ...updatedCount,
          all:
            (updatedCount.receipted ?? 0) +
            (updatedCount.pickupScheduled ?? 0) +
            (updatedCount.pickupCompleted ?? 0) +
            (updatedCount.warehoused ?? 0) +
            (updatedCount.deliveryAllocated ?? 0) +
            (updatedCount.postponed ?? 0) +
            (updatedCount.deliveryStarted ?? 0) +
            (updatedCount.deliveryCompleted ?? 0),
        },
      };
    case CONSTANTS.SET_COUNT_DELAYED:
      return {
        ...state,
        count: {
          ...state.count,
          delayed: action.countDelayed,
        },
      };
    case CONSTANTS.SET_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...action.query,
        },
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

const makeQueryStringObj = (query = INITIAL_QUERY) => {
  const queryTypes =
    query.queryTypes.includes(QUERY_DELIVERY_TYPE_ALL) ||
    query.queryTypes.includes(QUERY_DELIVERY_TYPE_TYPE_PICKUP) ||
    query.queryTypes.includes(QUERY_DELIVERY_TYPE_TYPE_RETURN) ||
    query.queryTypes.includes(QUERY_DELIVERY_TYPE_AGENCY_ALLOCATION_KOOKMIN)
      ? ""
      : query.queryTypes.join(";");

  let types = query.queryTypes.includes(QUERY_DELIVERY_TYPE_TYPE_PICKUP)
    ? "2"
    : query.queryTypes.includes(QUERY_DELIVERY_TYPE_TYPE_RETURN)
      ? "3"
      : query.types === "notInForCorpUserIds"
        ? "1"
        : query.types;

  let notInForCorpUserIds = [];

  if (process.env.REACT_APP_ENV === "production") {
    // 619: 마켓컬리즉시배송(kurlyProd)
    // 671: 올리브영퀵(cjoyquickapi)
    notInForCorpUserIds = [619, 671];
  } else {
    // 401: 마켓컬리즉시배송(kurlyProd)
    // 428: 올리브영퀵(cjoyquickapi)
    notInForCorpUserIds = [401, 428];
  }

  if (query.types === "notInForCorpUserIds") {
    if (process.env.REACT_APP_ENV === "production") {
      // 548: 한진(hanjinapi)
      // 583: 올리브영일반(cjoyapi)
      notInForCorpUserIds = [548, 583, 671, 619];
    } else {
      // 392: 한진(hanjinapi)
      // 398: 올리브영일반(cjoyapi)
      notInForCorpUserIds = [392, 398, 428, 401];
    }
  }

  let agencyCorpUserName = "";
  if (
    query.queryTypes.includes(QUERY_DELIVERY_TYPE_AGENCY_ALLOCATION_KOOKMIN)
  ) {
    agencyCorpUserName = AGENCY_KOOKMIN_CORPTITLE;
  }

  let region = "";
  let regionType = "";

  if (query.region) {
    const regionObj = REGIONS.find((r) => r.id === query.region);

    region = regionObj.name;
    regionType = regionObj.regionType;
  }

  return {
    ...query,
    queryTypes,
    types,
    agencyCorpUserName,
    region,
    regionType,
    notInForCorpUserIds,
  };
};

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useDeliveriesStore = () => {
  const api = useApiStore();
  const { dispatch, state } = useContext(Context);

  const allocateAgencyBulk = useCallback(
    async ({ agencyCorpUserName = AGENCY_KOOKMIN_USERNAME, deliveries }) => {
      return await Promise.allSettled(
        deliveries.map((delivery) =>
          api.post(`/agencies/${agencyCorpUserName}/allocate`, {
            bookId: delivery.bookId,
          }),
        ),
      );
    },
    [api.post],
  );

  const allocateDeliveryRiders = useCallback(
    ({ bookIds, riderId } = {}) =>
      api.put(`/deliveries/delivery-rider-allocation`, {
        bookIds,
        riderId,
      }),
    [api.put],
  );

  const allocatePickupRiders = useCallback(
    ({ bookIds, riderId } = {}) =>
      api.put(`/deliveries/pickup-rider-allocation`, {
        bookIds,
        riderId,
      }),
    [api.put],
  );

  const cancelAgencyBulk = useCallback(
    async ({ agencyCorpUserName = AGENCY_KOOKMIN_USERNAME, deliveries }) => {
      return await Promise.allSettled(
        deliveries.map((delivery) =>
          api.put(`/agencies/${agencyCorpUserName}/cancel`, {
            bookId: delivery.bookId,
          }),
        ),
      );
    },
    [api.put],
  );

  const countByStatus = useCallback(
    async ({ query }) => {
      const _query = {
        ...makeQueryStringObj(query),
        riderId: query.rider ? query.rider.id : "",
      };

      const dispatchCount = (key, value) => {
        dispatch({
          type: CONSTANTS.SET_COUNT_PARTIAL, // 개별 업데이트용 액션 추가 필요
          key,
          value,
        });
      };

      const requests = [
        {
          key: "receipted",
          queryTypeForCount: "receipted",
          types: query.types,
        },
        {
          key: "pickupScheduled",
          queryTypeForCount: "pickupScheduled",
          types: query.types,
        },
        {
          key: "pickupCompleted",
          queryTypeForCount: "pickupCompleted",
          types: query.types,
        },
        {
          key: "warehoused",
          queryTypeForCount: "warehoused",
          types: query.types,
        },
        {
          key: "deliveryAllocated",
          queryTypeForCount: "deliveryAllocated",
          types: query.types,
        },
        {
          key: "deliveryStarted",
          queryTypeForCount: "deliveryStarted",
          types: query.types,
        },
        {
          key: "deliveryCompleted",
          queryTypeForCount: "deliveryCompleted",
          types: query.types,
        },
        {
          key: "deliverySentBack",
          queryTypeForCount: "deliverySentBack",
          types: query.types,
        },
        {
          key: "deliveryLost",
          queryTypeForCount: "deliveryLost",
          types: query.types,
        },
        { key: "accident", queryTypeForCount: "accident", types: query.types },
        { key: "canceled", queryTypeForCount: "canceled", types: query.types },
        { key: "typePickup", types: "2" },
        { key: "typeReturn", types: "3" },
        {
          key: "postponed",
          queryTypeForCount: "postponed",
          types: query.types,
        },
        {
          key: "senderAddressError",
          queryTypeForCount: "senderAddressError",
          types: query.types,
        },
        {
          key: "senderAddressErrorCanceled",
          queryTypeForCount: "senderAddressErrorCanceled",
          types: query.types,
        },
        {
          key: "receiverAddressError",
          queryTypeForCount: "receiverAddressError",
          types: query.types,
        },
        {
          key: "receiverAddressErrorCanceled",
          queryTypeForCount: "receiverAddressErrorCanceled",
          types: query.types,
        },
        {
          key: "addressNotSupported",
          queryTypeForCount: "addressNotSupported",
          types: query.types,
        },
        {
          key: "addressNotSupportedCanceled",
          queryTypeForCount: "addressNotSupportedCanceled",
          types: query.types,
        },
      ];

      requests.forEach(({ key, ...params }) => {
        api
          .get("/deliveries/count-by-status/by-rider-group-managers", {
            ..._query,
            ...params,
          })
          .then((result) => dispatchCount(key, result))
          .catch((err) =>
            console.error(`Failed to fetch count for ${key}:`, err),
          );
      });

      api
        .get("/delayed-deliveries/list/by-rider-group-managers", {
          ...makeQueryStringObj(query),
          riderId: query.rider ? query.rider.id : "",
          types: query.types,
        })
        .then((result) =>
          dispatch({
            type: CONSTANTS.SET_COUNT_DELAYED,
            countDelayed: result.totalCount,
          }),
        )
        .catch((err) => console.error("Failed to fetch delayed count:", err));

      return true;
    },
    [api.get, dispatch],
  );

  const fetchAll = useCallback(
    async ({ query }) => {
      const { deliveries, pageCount } = await api.get(
        "/deliveries/by-rider-group-managers",
        {
          ...makeQueryStringObj(query),
          riderId: query.rider ? query.rider.id : "",
        },
      );

      dispatch({
        type: CONSTANTS.FETCH_ALL,
        deliveries: deliveries.map((d) => new Delivery(d)),
        deliveriesWholeData: deliveries,
        pageCount,
      });

      return { deliveries, pageCount };
    },
    [api.get, dispatch],
  );

  const fetchAllV2 = useCallback(
    async ({ query }) => {
      const { deliveries, pageCount } = await api.get(
        "/v2/deliveries/by-rider-group-managers",
        {
          ...makeQueryStringObj(query),
          riderId: query.rider ? query.rider.id : "",
        },
      );

      dispatch({
        type: CONSTANTS.FETCH_ALL,
        deliveries: deliveries.map((d) => new Delivery(d)),
        deliveriesWholeData: deliveries,
        pageCount,
      });

      return { deliveries, pageCount };
    },
    [api.get, dispatch],
  );

  const fetchAllDelayed = useCallback(
    async ({ query }) => {
      const deliveriesDelayed = await api.get(
        "/delayed-deliveries/list/by-rider-group-managers",
        {
          ...makeQueryStringObj(query),
          riderId: query.rider ? query.rider.id : "",
        },
      );

      dispatch({
        type: CONSTANTS.FETCH_ALL_DELAYED,
        deliveries: deliveriesDelayed.rows.map((d) => new Delivery(d)),
      });

      return { deliveriesDelayed };
    },
    [api.get, dispatch],
  );

  const fetchAllSelectedDeliveries = useCallback(
    async (deliveries) => {
      return await Promise.all(
        deliveries.map((delivery) => api.get(`/deliveries/${delivery.bookId}`)),
      );
    },
    [api.get],
  );

  const fetchAddressById = useCallback(
    async (bookId) => {
      return await api.get(`/deliveries/${bookId}/addresses`);
    },
    [api.get],
  );

  const fetchAllToReallocateOnTheFly = useCallback(
    async ({ deliveryStatus, dongId = "", riderId }) => {
      const { items } = await api.get("/deliveries/allocated", {
        deliveryStatus,
        dongId,
        riderId,
      });

      return items || [];
    },
    [api.get],
  );

  const fetchByIdOnTheFly = useCallback(
    (bookId) => api.get(`/deliveries/${bookId}`),
    [api.get],
  );

  const fetchDeliveryStatusLogs = useCallback(
    (bookId) => api.get(`/deliveries/${bookId}/delivery-status-logs/all`),
    [api.get],
  );

  // 회수로그
  const fetchDeliveryCollectionLogs = useCallback(
    (bookId) => api.get(`/delivery-collection-logs`, { bookId }),
    [api.get],
  );

  // 운송장 출력 로그
  const fetchDeliveryPrintLogs = useCallback(
    (bookId) => api.get(`/deliveries/${bookId}/print-label-logs`),
    [api.get],
  );

  const fetchForDownload = useCallback(
    ({ query }) => {
      return api.get("/deliveries/by-rider-group-managers/download", {
        ...makeQueryStringObj(query),
        orderBy: query.orderBy,
        riderId: query.rider ? query.rider.id : "",
      });
    },
    [api.get],
  );

  const fetchNotPrinted = useCallback(async () => {
    const { deliveries } = await api.get(
      "/deliveries/by-rider-group-managers",
      {
        ...makeQueryStringObj(state.query),
        riderId: state.query.rider ? state.query.rider.id : "",
        printed: false,
        page: 1,
        pageSize: 100,
      },
    );

    const deliveriesNotPrinted = deliveries.map((d) => new Delivery(d));

    return deliveriesNotPrinted;
  }, [api.get, state.query]);

  const printedBulk = useCallback(
    async (deliveries) => {
      return await Promise.allSettled(
        deliveries.map((delivery) =>
          api.put(`/deliveries/${delivery.bookId}/printed`, {
            printed: true,
          }),
        ),
      );
    },
    [api.put],
  );

  const resetQuery = useCallback(() => {
    dispatch({
      type: CONSTANTS.RESET_QUERY,
    });

    return INITIAL_QUERY;
  }, [dispatch]);

  const reset = useCallback(
    (reset) => {
      dispatch({
        type: CONSTANTS.RESET,
        reset,
      });
    },
    [dispatch],
  );

  const restoreCancel = useCallback(
    (bookIds = []) =>
      api.put(`/deliveries/restore/cancel`, {
        bookIds,
      }),
    [api.put],
  );

  const setDelayReason = useCallback(
    async (selectedDeliveries, data) => {
      return await Promise.allSettled(
        selectedDeliveries.map((delivery) =>
          api.put(`/deliveries/${delivery.bookId}/delay`, data),
        ),
      );
    },
    [api.put],
  );

  const setPreviousStatus = useCallback(
    (bookIds = []) =>
      api.put(`/deliveries/previous`, {
        bookIds,
      }),
    [api.put],
  );

  const setQuery = useCallback(
    (query = {}) => {
      dispatch({
        type: CONSTANTS.SET_QUERY,
        query,
      });
    },
    [dispatch],
  );

  const syncAgencyBulk = useCallback(
    async ({ deliveries }) => {
      return await Promise.allSettled(
        deliveries.map((delivery) =>
          api.put(`/deliveries/${delivery.bookId}/sync-with-agencies`),
        ),
      );
    },
    [api.put],
  );

  return {
    state,
    allocateAgencyBulk,
    allocateDeliveryRiders,
    allocatePickupRiders,
    cancelAgencyBulk,
    countByStatus,
    fetchAll,
    fetchAllV2,
    fetchAllDelayed,
    fetchAllSelectedDeliveries,
    fetchAddressById,
    fetchAllToReallocateOnTheFly,
    fetchByIdOnTheFly,
    fetchDeliveryStatusLogs,
    fetchDeliveryCollectionLogs,
    fetchDeliveryPrintLogs,
    fetchForDownload,
    fetchNotPrinted,
    printedBulk,
    reset,
    resetQuery,
    restoreCancel,
    setDelayReason,
    setPreviousStatus,
    setQuery,
    syncAgencyBulk,
  };
};
